const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: "PrivacyPolicy", // Add your PrivacyPolicy component
  },
  {
    path: "/terms-conditions",
    exact: true,
    component: "TermsConditions", // Add your TermsConditions component
  },
];

export default routes;
